import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '部门名称'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'nature',
    fieldName: '部门性质',
    url: 'DeptNature',
    selectType: 1,
    option: []
  }
]
